window.addEventListener('SITE_START', () => {
  const $section = document.querySelector('.our-business');
  if (!$section) return;

  const isDesktop = window.innerWidth >= 1024;
  const $inner = $section.querySelector('.__inner');
  const $cardContainer = $section.querySelector('.__card-box');
  const $cardList = $cardContainer.querySelector('.__card-list');
  const $cardCols = $cardContainer.querySelectorAll('.__col');
  const $text = $section.querySelector('.__text-box');

  // 📌 Desktop ---------------------------------------------
  if (isDesktop) {
    const PADDING_Y = 50;
    const contentBoxHeight = window.innerHeight - PADDING_Y * 2;
    const bottomOffset = $text.clientHeight / 2;
    const posY0 = $cardCols[0].clientHeight - contentBoxHeight + bottomOffset;
    const posY1 = $cardCols[1].clientHeight - contentBoxHeight;

    gsap.set($cardContainer, {
      opacity: 0,
      y: window.innerHeight / 2,
      willChange: 'transform, opacity',
    });
    gsap.to($cardContainer, {
      y: 0,
      opacity: 1,
      duration: 0.6,
      scrollTrigger: {
        trigger: $section,
        start: 'top 60%',
        id: 'appear',
        toggleActions: 'play none none reverse',
      },
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: $section,
        start: 'top top',
        end: '+=' + contentBoxHeight + 'px',
        pin: $inner,
        scrub: true,
        id: 'scrub',
        invalidateOnRefresh: true,
        // bg image opacity
        onEnter: () => gsap.to($section, { '--opacity': 1 }),
        onEnterBack: () => gsap.to($section, { '--opacity': 1 }),
        onLeave: () => gsap.to($section, { '--opacity': 0 }),
        onLeaveBack: () => gsap.to($section, { '--opacity': 0 }),
      },
    });

    tl.set($cardCols[0], { y: '40rem' });
    tl.set($cardCols[1], { y: '20rem' });
    tl.to($cardCols[0], { y: posY0 * -1, ease: 'linear' });
    tl.to($cardCols[1], { y: posY1 * -1, ease: 'linear' }, '<');
  }
  // 📌 Mobile ---------------------------------------------
  else {
    gsap.set($cardList, { y: '10rem', opacity: 0, willChange: 'transform, opacity' });
    gsap.to($cardList, {
      duration: 0.6,
      y: 0,
      opacity: 1,
      scrollTrigger: {
        trigger: $cardList,
        start: 'top 90%',
        id: 'appear',
      },
    });

    gsap.to($cardCols, {
      duration: 0.5,
      stagger: 0.2,
      opacity: 1,
      scrollTrigger: {
        trigger: $cardContainer,
        start: 'top 80%',
      },
    });

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: $cardContainer,
        start: 'top 80%',
        end: 'bottom bottom',
        scrub: true,
      },
    });

    gsap.set($cardCols[0], { y: 0 });
    gsap.set($cardCols[1], { y: '8rem' });

    timeline
      .to($cardCols[1], { y: 0 }) //
      .to($cardCols[0], { y: '8rem' }, '<')
      .to($cardContainer, { y: '-4rem' }, '<')
      .to($text, { opacity: 0 }, '<0.2');
  }
});
